import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch, useLocation, useRouteMatch } from 'react-router';
import { CAMPAIGN_PRODUCTS, COLLECTION_NAVIGATION_V2, useFeature } from '../../shared/utils/togglz';
import { ProductGroupOverview } from './productgroups/overview/ProductGroupOverview';
import { ProductGroupDetail } from './productgroups/detail/ProductGroupDetail';
import { AppState } from '../../store/appState';
import {
    LOANFORMAT_EAUDIOBOOK_OBJECT,
    LOANFORMAT_EBOOK_OBJECT,
    URL_LOANFORMAT_ALL,
    URL_LOANFORMAT_EAUDIOBOOKS,
    URL_LOANFORMAT_EBOOKS
} from '../../store/loanFormat/actions';
import { SortingView } from './productgroups/sorting/SortingView';
import { useEnvironment } from '../../shared/components/EnvironmentContext';
import { ENVIRONMENT_DEMO } from '../../constants';
import { YourCampaignsPage } from './campaigns/YourCampaignsPage';
import { CheckLoanFormat } from '../../shared/components/CheckLoanFormat';
import { ProductSelectionProvider } from '../../shared/product-selection/ProductSelectionContext';

const MarketingRouteSwitch: FC = () => {
    const { path, url } = useRouteMatch();
    const { pathname, search } = useLocation();
    const isCollectionNavigationV2Enabled = useFeature(COLLECTION_NAVIGATION_V2);
    const campaignsEnabled = useFeature(CAMPAIGN_PRODUCTS);
    // CatMan is not available in the demo environment
    const libraryManagedProductGroupsEnabled = useEnvironment() !== ENVIRONMENT_DEMO;
    const currentLoanFormat = useSelector((state: AppState) => {
        switch (state.loanFormat.key) {
            case LOANFORMAT_EBOOK_OBJECT.key:
                return URL_LOANFORMAT_EBOOKS;
            case LOANFORMAT_EAUDIOBOOK_OBJECT.key:
                return URL_LOANFORMAT_EAUDIOBOOKS;
            default:
                return URL_LOANFORMAT_ALL;
        }
    });

    return (
        <Switch>
            {campaignsEnabled ? (
                <Route exact path={`${path}/campaigns/:loanFormat`}>
                    {isCollectionNavigationV2Enabled ? (
                        <Redirect to={{ pathname: pathname.replace('/marketing', '/collectionmgmt'), search }} />
                    ) : (
                        <CheckLoanFormat>
                            <YourCampaignsPage />
                        </CheckLoanFormat>
                    )}
                </Route>
            ) : null}
            {libraryManagedProductGroupsEnabled ? (
                <Route exact path={`${path}/productgroups`}>
                    {isCollectionNavigationV2Enabled ? (
                        <Redirect to={{ pathname: pathname.replace('/marketing', '/merchandising'), search }} />
                    ) : (
                        <ProductGroupOverview />
                    )}
                </Route>
            ) : null}
            {libraryManagedProductGroupsEnabled ? (
                <Route exact path={`${path}/productgroups/:productGroupId`}>
                    {isCollectionNavigationV2Enabled ? (
                        <Redirect to={{ pathname: pathname.replace('/marketing', '/merchandising'), search }} />
                    ) : (
                        <ProductSelectionProvider>
                            <ProductGroupDetail />
                        </ProductSelectionProvider>
                    )}
                </Route>
            ) : null}
            {libraryManagedProductGroupsEnabled ? (
                <Route exact path={`${path}/productgroups/:productGroupId/sorting`}>
                    {isCollectionNavigationV2Enabled ? (
                        <Redirect to={{ pathname: pathname.replace('/marketing', '/merchandising'), search }} />
                    ) : (
                        <SortingView />
                    )}
                </Route>
            ) : null}
            {campaignsEnabled ? (
                <Route exact path={`${path}/campaigns`}>
                    <Redirect to={{ pathname: `${url}/campaigns/${currentLoanFormat}`, search }} />
                </Route>
            ) : null}
            {campaignsEnabled ? (
                <Route exact path={path}>
                    <Redirect to={{ pathname: `${url}/campaigns`, search }} />
                </Route>
            ) : libraryManagedProductGroupsEnabled ? (
                <Route exact path={path}>
                    <Redirect to={{ pathname: `${url}/productgroups`, search }} />
                </Route>
            ) : null}
            <Route>
                <Redirect to="/catalogue" />
            </Route>
        </Switch>
    );
};

export default MarketingRouteSwitch;
